"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = checkVerticalJustification;
// eslint-disable-next-line sonarjs/cognitive-complexity
function checkVerticalJustification(priceToCheckText, priceToCheckAgainstText) {
  var priceToCheckAgainstHasPrefixAndSuffix = priceToCheckAgainstText.prefix && priceToCheckAgainstText.suffix;
  if (priceToCheckAgainstText.prefix && !priceToCheckAgainstText.suffix || priceToCheckAgainstHasPrefixAndSuffix && priceToCheckText.suffix) return;
  if (!priceToCheckAgainstText.prefix && priceToCheckAgainstText.suffix || priceToCheckAgainstHasPrefixAndSuffix && priceToCheckText.prefix) return 'top';
  return 'center';
}
//# sourceMappingURL=checkVerticalJustification.js.map